import React, { useEffect, useState } from "react";
import { useStyles } from "./style";
import { useAppSelector } from "src/app-redux/hooks";
import { selectWereHouseDistributionData } from "src/app-redux/warehouse/wareHouseSlice";

export function WerehouseLevel2Table(): React.ReactElement {
  const classes = useStyles();
  const { inventryStatusLists }: any = useAppSelector(selectWereHouseDistributionData);

  const sum =
    inventryStatusLists && inventryStatusLists.reduce((a: any, b: any) => a + b.weight, 0);

  const unit = (weightUnit: any) => {
    return ` ${weightUnit ? (weightUnit == "Cubic meter" ? "m³" : weightUnit) : "KG"}`;
  };

  return (
    <>
      {inventryStatusLists?.length ? (
        <table className={classes.blueTable}>
          <thead className={classes.tHead}>
            <tr>
              <th className={`${classes.tableCells} ${classes.tHead}`}>Item Qty</th>
              <th className={`${classes.tableCells} ${classes.tHead}`}>Importer / Exporter</th>
              <th className={`${classes.tableCells} ${classes.tHead}`}>Qty</th>
              <th className={`${classes.tableCells} ${classes.tHead}`}>Qty Unit</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                rowSpan={inventryStatusLists.length + 1}
                className={`${classes.tableCells} ${classes.bodytd} ${classes.tdTotal}`}
              >
                {sum} {unit(inventryStatusLists[0]?.weightUnit)}
              </td>
            </tr>
            {inventryStatusLists &&
              inventryStatusLists.map((value: any, i: any) => (
                <tr key={i}>
                  <td className={`${classes.tableCells} ${classes.bodytd} ${classes.bodytdBT}`}>
                    {value?.importerName || ""}
                  </td>
                  <td className={`${classes.tableCells} ${classes.bodytd} ${classes.bodytdBT}`}>
                    {value?.weight}
                  </td>
                  <td className={`${classes.tableCells} ${classes.bodytd} ${classes.bodytdBT}`}>
                    {unit(value?.weightUnit)}
                  </td>
                </tr>
              ))}
            <tr>
              <td
                className={`${classes.tableCells} ${classes.bodytd} ${classes.tdTotal}`}
                colSpan={2}
              >
                Total
              </td>
              <td className={`${classes.tableCells} ${classes.bodytd} ${classes.tdTotal}`}>
                {sum}
              </td>
              <td className={`${classes.tableCells} ${classes.bodytd} ${classes.tdTotal}`}>
                {unit(inventryStatusLists[0]?.weightUnit)}
              </td>
            </tr>
          </tbody>
        </table>
      ) : (
        <div style={{ textAlign: "center", minWidth: "300px" }}>No data found</div>
      )}
    </>
  );
}
